<template>
  <table class="table">
    <tbody>
      <!-- Primera fila: # Empacador, Peso Caja, Total Clusters, Total Dedos -->
      <tr class="shadow-sm">
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong># Empacador: </strong>
          </h6>
          {{ boxInspectionData.packer || '-' }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong
              >Peso Caja ({{
                boxInspectionData.box && boxInspectionData.box.unit_tara_weight
                  ? boxInspectionData.box.unit_tara_weight
                  : 'lb'
              }}):
            </strong>
          </h6>
          {{
            boxInspectionData.weight
              ? formatNumber(boxInspectionData.weight)
              : '-'
          }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong>Total Clusters: </strong>
          </h6>
          {{ boxInspectionData.total_clusters || '-' }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong>Total Dedos: </strong>
          </h6>
          {{ boxInspectionData.total_fingers || '-' }}
        </td>
      </tr>

      <!-- Segunda fila: Calibre min, Calibre max, Long. min, Long. max -->
      <tr class="shadow-sm">
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong>Calibre min. (°): </strong>
          </h6>
          {{ boxInspectionData.min_calibration || '-' }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong>Calibre max. (°): </strong>
          </h6>
          {{ boxInspectionData.max_calibration || '-' }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong
              >Long. min. ({{
                boxInspectionData.box && boxInspectionData.box.unit_tara_length
                  ? boxInspectionData.box.unit_tara_length
                  : 'in'
              }}):
            </strong>
          </h6>
          {{ boxInspectionData.min_length || '-' }}
        </td>
        <td style="width: 25%">
          <h6 class="mb-2">
            <strong
              >Long. max. ({{
                boxInspectionData.box && boxInspectionData.box.unit_tara_length
                  ? boxInspectionData.box.unit_tara_length
                  : 'in'
              }}):
            </strong>
          </h6>
          {{ boxInspectionData.max_length || '-' }}
        </td>
      </tr>

      <tr class="shadow-sm">
        <td colspan="4">
          <h6 class="mb-2">
            <strong>{{ $t('production.defects') }}:</strong>
          </h6>
          <template v-if="hasDefects">
            <div
              class="mb-2"
              v-for="defect in boxInspectionData.box_inspection_defects"
              :key="defect.id"
            >
              <el-tag
                style="height: auto; color: black; width: 100%"
                type="info"
              >
                <div class="row pt-2">
                  <div class="col-12 col-sm-8 col-lg-6">
                    <h6 class="mb-2">
                      <strong>{{ $t('production.defect') }}</strong>
                    </h6>
                    <p>
                      {{ defect.quality_defect_subgroup.name }}
                    </p>
                  </div>
                  <div class="col-12 col-sm-4 col-lg-6">
                    <h6 class="mb-2">
                      <strong>{{
                        $t('boxinspection.cluster_quantity')
                      }}</strong>
                    </h6>
                    <p>
                      {{ defect.number_clusters }}
                    </p>
                  </div>
                </div>
              </el-tag>
            </div>
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm" v-if="hasClusters">
        <td colspan="4">
          <h6 class="mb-2">
            <strong>{{ $t('production.cluster') }}:</strong>
          </h6>
          <div class="px-3">
            <div class="row" style="overflow-x: auto">
              <table
                aria-describedby="table-clusters"
                class="table table-bordered p-4"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      style="min-width: 50px"
                    >
                      <strong>{{ $t('boxinspection.measurement') }}</strong>
                    </th>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      style="min-width: 50px"
                      v-for="(
                        cluster, indexCluster
                      ) in boxInspectionData.box_inspection_clusters"
                      :key="`header-${cluster.id}-${indexCluster}`"
                    >
                      <strong>{{ cluster.cluster_number }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-center">
                      {{ $t('boxinspection.cluster_number') }}
                    </td>
                    <td
                      class="text-center"
                      v-for="(
                        cluster, indexCluster
                      ) in boxInspectionData.box_inspection_clusters"
                      :key="`cluster-number-${cluster.id}-${indexCluster}`"
                    >
                      {{ cluster.cluster_number }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      {{ $t('common_words.weight') }} (lb)
                    </td>
                    <td
                      class="text-center"
                      v-for="(
                        cluster, indexCluster
                      ) in boxInspectionData.box_inspection_clusters"
                      :key="`cluster-weight-${cluster.id}-${indexCluster}`"
                    >
                      {{ formatNumber(cluster.weight) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MasterTable from 'src/components/Tables/MasterTable.vue';
import mixinMasters from 'src/util/mixinMasters';
import moment from 'moment';

export default {
  name: 'box-inspection-table',
  components: {
    MasterTable,
  },
  props: {
    boxInspectionData: {
      type: Object,
      default: null,
    },
  },

  mixins: [mixinMasters],

  data() {
    return {
      qualityPercentages: [],
      compliancePercentage: 0,
    };
  },

  computed: {
    hasDefects() {
      if (
        !isset(this.boxInspectionData) ||
        !isset(this.boxInspectionData.box_inspection_defects)
      ) {
        return false;
      }
      return this.boxInspectionData.box_inspection_defects.length > 0;
    },

    hasClusters() {
      if (
        !isset(this.boxInspectionData) ||
        !isset(this.boxInspectionData.box_inspection_clusters)
      ) {
        return false;
      }
      return this.boxInspectionData.box_inspection_clusters.length > 0;
    },
  },

  methods: {
    getClusterTableColumns() {
      return [
        {
          prop: 'cluster_number',
          label: this.$t('boxinspection.cluster_number'),
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'weight',
          label: this.$t('common_words.weight') + ' (lb)',
          minWidth: 130,
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.weight);
          },
        },
      ];
    },

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    isSet(data) {
      return isset(data);
    },

    getAnalyticsTableColumns() {
      // Obtener la unidad de peso de la caja
      const weightUnit =
        this.boxInspectionData.box &&
        this.boxInspectionData.box.unit_tara_weight
          ? this.boxInspectionData.box.unit_tara_weight
          : 'lb';

      return [
        {
          prop: 'number_box',
          label: this.$t('production.box'),
          align: 'center',
          minWidth: 20,
        },
        {
          label:
            this.$t('common_words.weight') +
            ' (' +
            weightUnit +
            ')' +
            this.getMinWeightText(),
          prop: 'weight',
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.weight);
          },
          minWidth: 50,
        },
        {
          label: this.$t('boxinspection.pcms') + ' (%)' + this.getMinPCMSText(),
          prop: 'pcms',
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.pcms);
          },
          minWidth: 50,
        },
        {
          label:
            this.$t('boxinspection.total_underweight_fingers') +
            this.getMinUnderweightText(),
          prop: 'total_underweight_fingers',
          align: 'center',
          formatter: (row) => {
            return row.total_underweight_fingers;
          },
        },
      ];
    },

    getAnalyticsTableData() {
      const data = [];

      if (!this.boxInspectionData.box_inspection_boxes) {
        return data;
      }

      let totalPcms = 0;
      let totalUnderweightFingers = 0;
      let totalWeight = 0;

      this.boxInspectionData.box_inspection_boxes.forEach((box, index) => {
        // Calcular PCMS
        const pcms = this.calculatePCMS(box);

        // Calcular gajos bajo peso (asumiendo que se calcula basado en clusters < 2lb)
        const underweightFingers = this.calculateUnderweightFingers(box);

        // Peso de la caja
        const weight = parseFloat(box.weight) || 0;

        // Acumular totales
        totalPcms += pcms;
        totalUnderweightFingers += underweightFingers;
        totalWeight += weight;

        data.push({
          number_box: box.box_number,
          weight: weight,
          pcms: pcms,
          total_underweight_fingers: underweightFingers,
        });
      });

      // Agregar fila de totales
      const averagePcms =
        this.boxInspectionData.box_inspection_boxes.length > 0
          ? totalPcms / this.boxInspectionData.box_inspection_boxes.length
          : 0;

      const averageWeight =
        this.boxInspectionData.box_inspection_boxes.length > 0
          ? totalWeight / this.boxInspectionData.box_inspection_boxes.length
          : 0;

      data.push({
        number_box: '',
        weight: averageWeight,
        pcms: averagePcms,
        total_underweight_fingers: totalUnderweightFingers,
        isTotal: true,
      });

      return data;
    },

    calculatePCMS(box) {
      const totalClusters = box.total_clusters || 0;

      if (totalClusters === 0) {
        return 100; // Si no hay clusters, PCMS es 100%
      }

      // Calcular clusters descontables basado en defectos
      const discountableClusters = this.calculateDiscountableClusters(box);

      // Aplicar fórmula PCMS: ((Total Clusters - Cant. Cluster descontables) / Total Clusters) * 100
      const pcms =
        ((totalClusters - discountableClusters) / totalClusters) * 100;

      // Limitar a 2 decimales y asegurar que no sea negativo
      return Math.max(0, Math.round(pcms * 100) / 100);
    },

    calculateDiscountableClusters(box) {
      let discountableClusters = 0;

      if (box.box_inspection_defects && box.box_inspection_defects.length > 0) {
        box.box_inspection_defects.forEach((defect) => {
          // Asumiendo que todos los defectos son descontables por defecto
          // En un caso real, deberías verificar si el defecto tiene la propiedad discountable
          discountableClusters += defect.number_clusters || 0;
        });
      }

      return discountableClusters;
    },

    calculateUnderweightFingers(box) {
      // Para este cálculo, necesitaríamos datos de clusters individuales
      // Por ahora, retornamos 0 ya que no tenemos esa información en la estructura actual
      // En un caso real, esto se calcularía basado en los clusters con peso < 2lb
      return 0;
    },

    getMinWeightText() {
      // Obtener el peso mínimo de la caja
      const minWeight =
        this.boxInspectionData.box && this.boxInspectionData.box.min_weight
          ? this.boxInspectionData.box.min_weight
          : null;

      if (minWeight) {
        const weightUnit =
          this.boxInspectionData.box &&
          this.boxInspectionData.box.unit_tara_weight
            ? this.boxInspectionData.box.unit_tara_weight
            : 'lb';

        return ` (Min: ${minWeight} ${weightUnit})`;
      }

      return '';
    },

    getMinPCMSText() {
      // Mostrar el porcentaje mínimo de cumplimiento requerido
      if (this.compliancePercentage > 0) {
        return ` (Min: ${this.compliancePercentage}%)`;
      }

      return '';
    },

    getMinUnderweightText() {
      // Mostrar el límite mínimo de gajos bajo peso (actualmente fijo en 2 lb)
      return ' (Min: 2 lb)';
    },

    getAnalyticsCellStyle({ row, column, rowIndex, columnIndex }) {
      // Si es la fila de totales, no aplicar color
      const columnProp = column.property;
      if (row.isTotal && columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (row.isTotal) {
        return {};
      }

      // Aplicar colores según la columna
      if (columnProp === 'weight') {
        return this.getWeightCellStyle(row);
      } else if (columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (columnProp === 'total_underweight_fingers') {
        return this.getUnderweightFingersCellStyle(row);
      }

      return {};
    },

    getWeightCellStyle(row) {
      // Obtener el peso mínimo de la caja
      const minWeight =
        this.boxInspectionData.box && this.boxInspectionData.box.min_weight
          ? parseFloat(this.boxInspectionData.box.min_weight)
          : 0;

      const currentWeight = parseFloat(row.weight) || 0;

      // Si el peso actual es mayor o igual al mínimo, verde claro, sino rojo claro
      if (currentWeight >= minWeight) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getPCMSCellStyle(row) {
      const currentPcms = parseFloat(row.pcms) || 0;

      // Si el PCMS es mayor o igual al porcentaje mínimo, verde claro, sino rojo claro
      if (currentPcms >= this.compliancePercentage) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getUnderweightFingersCellStyle(row) {
      const currentUnderweightFingers =
        parseInt(row.total_underweight_fingers) || 0;

      // Si hay 0 gajos bajo peso, verde claro, sino rojo claro
      if (currentUnderweightFingers === 0) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    loadQualityPercentages() {
      this.showHideLoading(true);
      Axios.getMasters('quality/qualitypercentages')
        .then((response) => {
          this.qualityPercentages = response.data.data;

          // Seleccionar el porcentaje correspondiente a la fecha
          this.selectCompliancePercentage();
          this.showHideLoading();
        })
        .catch((error) => {
          console.error('Error loading quality percentages:', error);
          this.compliancePercentage = 0; // Valor por defecto
          this.showHideLoading();
        });
    },

    selectCompliancePercentage() {
      if (
        !this.boxInspectionData.date_save ||
        this.qualityPercentages.length === 0
      ) {
        this.compliancePercentage = 0;
        return;
      }

      const selectedDate = new Date(this.boxInspectionData.date_save);

      // Buscar el porcentaje más reciente que no exceda la fecha seleccionada
      let selectedPercentage = null;

      for (const percentage of this.qualityPercentages) {
        const percentageDate = new Date(percentage.start_date);
        if (percentageDate <= selectedDate) {
          if (
            !selectedPercentage ||
            percentageDate > new Date(selectedPercentage.start_date)
          ) {
            selectedPercentage = percentage;
          }
        }
      }

      this.compliancePercentage = selectedPercentage
        ? parseFloat(selectedPercentage.percentage)
        : 0;
    },
  },

  created() {
    // Cargar porcentajes de calidad cuando se crea el componente
    this.loadQualityPercentages();
  },
};
</script>

<style scoped>
/* Estilos específicos para la tabla de analíticas */
.analytics-table ::v-deep .el-table__body tr:last-child {
  font-weight: bold;
}

.analytics-table ::v-deep .el-table__body tr:last-child td {
  font-weight: bold;
  border-top: 2px solid #6ba652;
}

/* Estilos para el texto en negrita en la fila de totales de la tabla de analíticas */
.analytics-table ::v-deep .el-table__body tr:last-child td strong {
  color: #6ba652;
}
</style>
